import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
    state: () => ({
        routeIsLoading: false,
    }),

    actions: {
        setRouteLoading(loading) {
            this.routeIsLoading = loading
        },
    },
})
